import { useCallback, useContext, useMemo } from 'react';

import { get, has } from 'lodash';

import { MainContext } from '@ezbobdev/ui-framework';

import widgetsDefault from './widgetsDefault.json';

const getConfigByName = (name, configBy) => {
  if (!name) return '';

  return `${name}${configBy ? `.${configBy}` : ``}`;
};

export const useUtils = (props, widgetName) => {
  const { actions, config } = useContext(MainContext);
  const { name, configBy } = props;

  const configByName = useMemo(() => getConfigByName(name, configBy), [name, configBy, getConfigByName]);

  const getConfig = useCallback(
    (property, defaultValue) => {
      // From prop
      if (has(props, property)) return get(props, property);

      // From config
      const configValue = actions.settings.getUserConfigProp(`widgetsConfig.${configByName}.${property}`);
      if (configValue !== undefined) return configValue;

      // From widget global config
      const configDefaultValue = actions.settings.getUserConfigProp(`widgetsConfig.globals.${widgetName}.${property}`);
      if (configDefaultValue !== undefined) return configDefaultValue;

      // From widget default
      const widgetDefaultConfig = widgetName ? get(widgetsDefault, `${widgetName}.${property}`) : undefined;
      if (widgetDefaultConfig !== undefined) return widgetDefaultConfig;

      // Default
      return defaultValue;
    },
    [props, configByName, config],
  );

  return { configByName, getConfig };
};
